import { colors } from '@amazd/common/static';
import { makeStyles } from '@mui/styles';

export default makeStyles(() => ({
  form: {
    marginTop: '40px',
    paddingBottom: '16px',

    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
  paper: {
    backgroundColor: 'white',
    width: '100%',
    borderRadius: '16px',
    maxWidth: '1280px',
    padding: `40px 48px 48px 48px`,
    display: 'flex',
    flexDirection: 'column',
    gap: 32,
  },
  headerText: {
    fontSize: '24px',
    lineHeight: '32px',
    fontWeight: 500,
    color: colors.black,
  },
  actions: {
    display: 'flex',
    flexDirection: 'row',
    alignSelf: 'flex-end',
    gap: 16,
  },
  button: {
    paddingLeft: '24px',
    paddingRight: '24px',
  },
  colorInput: {
    '& .MuiFormHelperText-root': {
      fontSize: '14px',
      lineHeight: '20px',
    },
  },
  avatar: {
    width: 80,
    height: 80,
    minWidth: 80,
    borderRadius: 40,
  },
  avatarControl: {
    marginTop: '20px !important',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridColumnGap: 32,
  },
  handle: {
    marginTop: 8,
  },
  callLengthInput: {
    maxWidth: 250,
  },
  marginTop32: {
    marginTop: '32px !important',
  },
}));
